export enum DeliveryTypesEnum {
  DELIVERY = 'delivery',
  STANDARD_DELIVERY = 'standard_delivery',
  PICK_UP = 'pick_up',
  EXPRESS = 'express',
  EXPRESS_DELIVERY = 'express_delivery',
}
